var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isActivated)?_c('div',[_vm._v("Some kind of welcome message here.")]):_c('div',[_c('h2',{staticClass:"title"},[_vm._v(" Your account has not been activated yet. Please try again later. ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }